import {observer} from 'mobx-react';
import {Panel, FormLayout, Input, TextArea, Select2} from 'shared/components';
import {t} from 'shared/core';

const InterviewDetails = observer(({uiState}) => {
  const {interviewSchedule, errors} = uiState;

  return (
    <div>
      <Panel.Header title={t('recruiting.interview_schedules.edit.Interview Details')}/>
      <FormLayout>
        <Input
          value={interviewSchedule.templateName}
          label='recruiting.interview_schedules.edit.Name'
          onChange={e => interviewSchedule.merge({templateName: e.target.value})}
          errorMessage={errors.templateName}
        />
        <Input
          value={interviewSchedule.calendarEventName}
          label='recruiting.interview_schedules.edit.Event Title'
          onChange={e => interviewSchedule.merge({calendarEventName: e.target.value})}
          errorMessage={errors.calendarEventName}
        />
        <TextArea
          value={interviewSchedule.eventDescription}
          onChange={e => interviewSchedule.merge({eventDescription: e.target.value})}
          label='recruiting.interview_schedules.edit.Description'
          errorMessage={errors.eventDescription}
        />
        <FormLayout.Group>
          <Input
            label='recruiting.interview_schedules.edit.Duration'
            value={interviewSchedule.duration}
            onChange={e => interviewSchedule.merge({duration: e.target.value})}
            connectedRight={
              <div className='InputGroup'>
                <span className='InputGroup-tag small'>{t(`recruiting.interview_schedules.edit.minutes`)}</span>
              </div>
            }
            errorMessage={errors.duration}
          />
          <Select2
            value={interviewSchedule.location}
            label='recruiting.interview_schedules.edit.Meeting Location'
            onChange={e => interviewSchedule.merge({location: e.target.value})}
            errorMessage={errors.location}
          >
            <option key='phone' value='phone'>{t('recruiting.interview_schedules.edit.meeting_locations.Phone')}</option>
            <option key='in_person' value='in_person'>{t('recruiting.interview_schedules.edit.meeting_locations.In-Person')}</option>
            <option key='video_conferencing' value='video_conferencing'>{t('recruiting.interview_schedules.edit.meeting_locations.Video Call')}</option>
          </Select2>
        </FormLayout.Group>
      </FormLayout>
    </div>
  );
});

export default InterviewDetails;
